import { z } from 'zod'
import { optionalText, requiredText } from '../../../lib/forms/rules'

/**
 * Ülke ekle/düzenle form şeması (026): nameTr zorunlu; nameEn opsiyonel. Sıra (SORT_INDEX) formda yok —
 * sıralama tablodaki ↑/↓ oklarından yapılır (oluşturmada sona otomatik atanır).
 */
export const countryFormSchema = z.object({
  nameTr: requiredText(),
  nameEn: optionalText(),
})

export type CountryFormValues = z.infer<typeof countryFormSchema>
